import { SessionService } from './session.service';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { ProfileWritableEntities } from './shared-constants';
import { firstValueFrom, Observable, filter } from 'rxjs';
import { map } from 'rxjs/operators';
import _ from 'lodash';
import { NotificationService } from '@progress/kendo-angular-notification';

@Injectable()
export class ProfileService {
	public profile: Observable<object | never> = this.afAuth.user.pipe(
		filter(x => !!x),
		map(u => _.pick(u.toJSON(), 'displayName', 'photoURL')),
		map((x: any) => ({ displayName: x.displayName || '', photoURL: x.photoURL || '' }))
	);

	constructor(
		private afAuth: AngularFireAuth,
		private notificationService: NotificationService,
		private sessionService: SessionService
	) {}

	get(): Observable<any> {
		return this.profile;
	}
	getProfile(): Observable<any> {
		return this.profile;
	}

	hydrate(): Observable<any> {
		return this.profile;
	}

	async updateProfile(data: ProfileWritableEntities): Promise<any> {
		const user = await firstValueFrom(this.afAuth.user);

		await user.updateProfile({
			displayName: data.displayName || '',
			photoURL: data.photoURL || ''
		});

		await firstValueFrom(this.sessionService.reload());
	}
}
